import { createContext, useContext, useState, useCallback } from "react";

export const dictionaries = {
  mk: {
    nav: {
      apartments: "Апартмани",
      hotels: "Хотели",
      about: "Гевгелија",
      villas: "Вили",
      vehicles: "Возила",
      motorcycles: "Мотори",
      bicycles: "Велосипеди",
      catering: "Настани и кетеринг",
      tours: "Тури и водич",
      contact: "Контакт",
      book: "Резервирај",
      brand: "Рент Центер Гевгелија",
    },
    hero: {
      line1: "Апартмани, вили,",
      line2: "коли, мотори, велосипеди —",
      line3: "сè во Гевгелија.",
      sub: "Апартмани, вили, коли, мотори и велосипеди — сè за твојот престој во Гевгелија, на една страница.",
      ctaExplore: "Разгледај апартмани",
      ctaContact: "Испрати прашање",
      stats1: "апартмани",
      stats2: "локации во градот",
      stats3: "поддршка",
      scroll: "Скролај",
    },
    marquee: ["Термални извори", "Ривиера на Вардар", "Бутик сместување", "Град на палми", "Казино ноќен живот", "Домашна пречека"],
    callStrip: { label: "Јави ни се директно" },
    villas: { kicker: "Наскоро", title: "Вили", sub: "Работиме на додавање вили во понудата. Ако сакаш вила — јави ни се на Viber или WhatsApp." },
    hotels: { kicker: "Наскоро", title: "Хотели", sub: "Работиме на додавање хотели во понудата. Ако сакаш хотел — јави ни се на Viber или WhatsApp." },
    hotel: {
      sub: "Премиум Инн — хотел во Гевгелија со 6 типови на соби. Избери тип на соба за повеќе информации.",
      subFeniks: "Феникс — хотел во Гевгелија со 3 типови на соби. Избери тип на соба за повеќе информации.",
      roomSub: "Деталите, цените и фотографиите за оваа соба наскоро ќе бидат објавени. За информации јави ни се на Viber или WhatsApp.",
      roomInfo: "За резервации и дополнителни информации јави ни се на Viber или WhatsApp.",
      waRoom: "Здраво! Ме интересира {room} во хотелот {hotel} — дали имате слободни термини?",
      rooms: { deluxeApartment: "Deluxe Апартман", deluxeFamilyRoom: "Deluxe Семејна Соба", familySuite: "Семеен Суит", quadrupleRoom: "Четворокреветна Соба", tripleRoom: "Трокреветна Соба", doubleRoom: "Двокреветна Соба", commonAreas: "Заеднички простории" },
    },
    rental: { vehicles: "Изнајмување возила", motorcycles: "Изнајмување мотори", bicycles: "Изнајмување велосипеди", catering: "Изнајмување за настани и кетеринг", motoAll: "Сите", tours: "Локални тури и туристички водич", sub: "Наскоро — работиме на понудата. За информации јави ни се на Viber или WhatsApp." },
    grid: {
      kicker: "Колекција",
      tabAll: "Сите",
      greenPlace: "Green Place Апартмани",
      title: "Апартманите",
      subtitle: "Секој апартман е посебна приказна — избери ја твојата.",
      guests: "гости",
      bedrooms: "спални",
      studio: "студио",
      night: "ноќ",
      from: "од",
      view: "Види детали",
      perNight: "/ ноќ",
      comingSoon: "Наскоро",
      comingSoonDetail: "Овој апартман наскоро ќе биде достапен за резервации. За информации јави се на +389 78 321 872 или испрати порака.",
    },
    manifesto: {
      kicker: "Манифест",
      title: "Зошто Гевгелија",
      ch1t: "Градот на палмите",
      ch1d: "Најјужниот град на Македонија дише медитерански — палми долж булеварите, кафулиња што никогаш не брзаат и сонце што останува подолго отколку насекаде.",
      ch2t: "Термални извори",
      ch2d: "На неколку минути од центарот, природните термални бањи на Смрдлива Вода нудат одмор што Римјаните го знаеле пред два милениуми.",
      ch3t: "Ривиерата на Вардар",
      ch3d: "Граничната ривиера комбинира казина, ресторани и ноќен живот со тивкото темпо на реката — контраст што не се наоѓа никаде на Балканот.",
    },
    detail: {
      back: "Сите апартмани",
      availability: "Достапност",
      selectDates: "Избери датуми",
      checkIn: "Пријава",
      checkOut: "Одјава",
      guests: "Гости",
      guest: "гост",
      guestsP: "гости",
      nights: "ноќи",
      night: "ноќ",
      total: "Вкупно",
      perNight: "за ноќ",
      bookPay: "Резервирај и плати",
      processing: "Се обработува…",
      bookedLegend: "зафатено",
      selectedLegend: "избрано",
      yourStay: "Твојот престој",
      bookVia: "Резервирај преку Viber / WhatsApp",
      bookViaSub: "Испрати ни порака на Viber или WhatsApp со апартманот и датумите што те интересираат — одговараме истиот ден.",
      orCall: "или јави се директно",
      waMsg: "Здраво! Ме интересира {name} — дали имате слободни термини?",
      name: "Име и презиме",
      email: "Е-пошта",
      phone: "Телефон",
      note: "Забелешка (опционално)",
      namePh: "пр. Петар Петров",
      notePh: "Посакано време на пристигнување, прашања…",
      errDates: "Избери валидни датуми за пријава и одјава.",
      errOverlap: "Избраните датуми се веќе зафатени.",
      errGeneric: "Нешто тргна наопаку. Обиди се повторно.",
      amenities: "Погодности",
      about: "За апартманот",
      amenityList: {
        wifi: "Брз Wi-Fi",
        parking: "Сопствен паркинг",
        ac: "Клима",
        kitchen: "Целосна кујна",
        kitchenette: "Мини кујна",
        terrace: "Тераса",
        tv: "Smart TV",
        washer: "Машина за перење",
        dishwasher: "Машина за садови",
        coffee: "Кафе апарат",
        workspace: "Работен агол",
        view: "Панорамски поглед",
        blackout: "Затемнување",
        sauna: "Приватна сауна",
        jacuzzi: "Џакузи",
        garden: "Голем двор",
        summerKitchen: "Летна кујна",
      },
    },
    contact: {
      kicker: "Контакт",
      title: "Имаш прашање?",
      subtitle: "Пиши ни за достапност, посебни понуди или подолги престои — одговараме истиот ден.",
      name: "Име",
      email: "Е-пошта",
      message: "Порака",
      send: "Испрати порака",
      sending: "Се испраќа…",
      success: "Пораката е испратена. Ќе ти одговориме наскоро!",
      error: "Испраќањето не успеа. Обиди се повторно.",
      namePh: "Твоето име",
      emailPh: "tebe@primer.com",
      messagePh: "Здраво, ме интересира…",
      phoneLabel: "Телефон / WhatsApp / Viber",
      phoneNote: "Достапни сме на WhatsApp и Viber",
      emailLabel: "Е-пошта",
      locationLabel: "Локација",
    },
    footer: {
      tagline: "Бутик апартмани под закирн во Гевгелија — една страница, сите локации.",
      explore: "Истражи",
      contact: "Контакт",
      rights: "Сите права задржани.",
      apartments: "Апартмани",
      about: "За Гевгелија",
    },
    payment: {
      successTitle: "Резервацијата е потврдена",
      successSub: "Плаќањето е успешно. Деталите за резервацијата се подолу — потврда ќе добиеш и на е-пошта.",
      polling: "Ја проверуваме уплатата…",
      bookingRef: "Референца",
      dates: "Датуми",
      paid: "Платено",
      backHome: "Назад кон почетна",
      cancelTitle: "Плаќањето е откажано",
      cancelSub: "Резервацијата не е завршена. Датумите може да се уште слободни — обиди се повторно.",
      tryAgain: "Обиди се повторно",
      failed: "Уплатата не е потврдена. Ако парите ти се одземени, контактирај нè.",
    },
    cal: {
      months: ["Јануари", "Февруари", "Март", "Април", "Мај", "Јуни", "Јули", "Август", "Септември", "Октомври", "Ноември", "Декември"],
      days: ["По", "Вт", "Ср", "Че", "Пе", "Са", "Не"],
      prev: "Претходен месец",
      next: "Следен месец",
    },
    notFound: "Страницата не постои.",
  },
  en: {
    nav: {
      apartments: "Apartments",
      hotels: "Hotels",
      about: "Gevgelija",
      villas: "Villas",
      vehicles: "Vehicles",
      motorcycles: "Motorcycles",
      bicycles: "Bicycles",
      catering: "Events & Catering",
      tours: "Tours & Guide",
      contact: "Contact",
      book: "Book now",
      brand: "Rent Center Gevgelija",
    },
    hero: {
      line1: "Apartments, villas,",
      line2: "cars, motorcycles, bicycles —",
      line3: "all in Gevgelija.",
      sub: "Apartments, villas, cars, motorcycles and bicycles — everything for your stay in Gevgelija, on a single site.",
      ctaExplore: "Explore apartments",
      ctaContact: "Send an enquiry",
      stats1: "apartments",
      stats2: "city locations",
      stats3: "support",
      scroll: "Scroll",
    },
    marquee: ["Thermal springs", "Vardar Riviera", "Boutique stays", "City of palms", "Casino nightlife", "Homestyle welcome"],
    callStrip: { label: "Call us directly" },
    villas: { kicker: "Coming soon", title: "Villas", sub: "We are adding villas to our collection. If you are looking for a villa — message us on Viber or WhatsApp." },
    hotels: { kicker: "Coming soon", title: "Hotels", sub: "We are adding hotels to our collection. If you are looking for a hotel — message us on Viber or WhatsApp." },
    hotel: {
      sub: "Premium Inn — a hotel in Gevgelija with 6 room types. Pick a room type for more info.",
      subFeniks: "Fenix — a hotel in Gevgelija with 3 room types. Pick a room type for more info.",
      roomSub: "Details, prices and photos for this room will be published soon. For info message us on Viber or WhatsApp.",
      roomInfo: "For reservations and more info message us on Viber or WhatsApp.",
      waRoom: "Hello! I am interested in the {room} at {hotel} hotel — do you have available dates?",
      rooms: { deluxeApartment: "Deluxe Apartment", deluxeFamilyRoom: "Deluxe Family Room", familySuite: "Family Suite", quadrupleRoom: "Quadruple Room", tripleRoom: "Triple Room", doubleRoom: "Double Room", commonAreas: "Common Areas" },
    },
    rental: { vehicles: "Vehicle rental", motorcycles: "Motorcycle rental", bicycles: "Bicycle rental", catering: "Event Rentals and Catering", motoAll: "All", tours: "Local Tours & Tourist Guide", sub: "Coming soon — we are preparing the offer. For info message us on Viber or WhatsApp." },
    grid: {
      kicker: "The collection",
      tabAll: "All",
      greenPlace: "Green Place Apartments",
      title: "The Apartments",
      subtitle: "Each apartment is its own story — pick yours.",
      guests: "guests",
      bedrooms: "bedrooms",
      studio: "studio",
      night: "night",
      from: "from",
      view: "View details",
      perNight: "/ night",
      comingSoon: "Coming soon",
      comingSoonDetail: "This apartment will be available for booking soon. For info call +389 78 321 872 or send us a message.",
    },
    manifesto: {
      kicker: "Manifesto",
      title: "Why Gevgelija",
      ch1t: "The city of palms",
      ch1d: "Macedonia's southernmost town breathes Mediterranean — palms along the boulevards, cafés that never hurry, and sun that lingers longer than anywhere else.",
      ch2t: "Thermal springs",
      ch2d: "Minutes from the centre, the natural thermal baths of Smrdliva Voda offer the kind of rest the Romans already knew two millennia ago.",
      ch3t: "The Vardar Riviera",
      ch3d: "The border strip pairs casinos, restaurants and nightlife with the slow tempo of the river — a contrast found nowhere else in the Balkans.",
    },
    detail: {
      back: "All apartments",
      availability: "Availability",
      selectDates: "Select your dates",
      checkIn: "Check-in",
      checkOut: "Check-out",
      guests: "Guests",
      guest: "guest",
      guestsP: "guests",
      nights: "nights",
      night: "night",
      total: "Total",
      perNight: "per night",
      bookPay: "Book & pay",
      processing: "Processing…",
      bookedLegend: "booked",
      selectedLegend: "selected",
      yourStay: "Your stay",
      bookVia: "Book via Viber / WhatsApp",
      bookViaSub: "Send us a Viber or WhatsApp message with the apartment and dates you want — we reply the same day.",
      orCall: "or call us directly",
      waMsg: "Hello! I am interested in {name} — do you have available dates?",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      note: "Note (optional)",
      namePh: "e.g. Peter Petrov",
      notePh: "Arrival time, questions…",
      errDates: "Please select valid check-in and check-out dates.",
      errOverlap: "The selected dates are already booked.",
      errGeneric: "Something went wrong. Please try again.",
      amenities: "Amenities",
      about: "About this apartment",
      amenityList: {
        wifi: "Fast Wi-Fi",
        parking: "Private parking",
        ac: "Air conditioning",
        kitchen: "Full kitchen",
        kitchenette: "Kitchenette",
        terrace: "Terrace",
        tv: "Smart TV",
        washer: "Washing machine",
        dishwasher: "Dishwasher",
        coffee: "Coffee machine",
        workspace: "Work corner",
        view: "Panoramic view",
        blackout: "Blackout curtains",
        sauna: "Private sauna",
        jacuzzi: "Jacuzzi",
        garden: "Large garden",
        summerKitchen: "Summer kitchen",
      },
    },
    contact: {
      kicker: "Contact",
      title: "Have a question?",
      subtitle: "Ask about availability, special offers or longer stays — we reply the same day.",
      name: "Name",
      email: "Email",
      message: "Message",
      send: "Send message",
      sending: "Sending…",
      success: "Message sent. We'll get back to you soon!",
      error: "Sending failed. Please try again.",
      namePh: "Your name",
      emailPh: "you@example.com",
      messagePh: "Hello, I'm interested in…",
      phoneLabel: "Phone / WhatsApp / Viber",
      phoneNote: "We're available on WhatsApp and Viber",
      emailLabel: "Email",
      locationLabel: "Location",
    },
    footer: {
      tagline: "Boutique apartments for rent in Gevgelija — one site, every location.",
      explore: "Explore",
      contact: "Contact",
      rights: "All rights reserved.",
      apartments: "Apartments",
      about: "About Gevgelija",
    },
    payment: {
      successTitle: "Booking confirmed",
      successSub: "Payment successful. Your booking details are below — a confirmation will also reach your inbox.",
      polling: "Verifying your payment…",
      bookingRef: "Reference",
      dates: "Dates",
      paid: "Paid",
      backHome: "Back to home",
      cancelTitle: "Payment cancelled",
      cancelSub: "Your booking was not completed. The dates may still be free — try again.",
      tryAgain: "Try again",
      failed: "Payment not confirmed. If money was taken from your account, contact us.",
    },
    cal: {
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      days: ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"],
      prev: "Previous month",
      next: "Next month",
    },
    notFound: "Page not found.",
  },
  el: {
    nav: { apartments: "Διαμερίσματα", hotels: "Ξενοδοχεία", about: "Γκέβγελι", villas: "Βίλες", vehicles: "Οχήματα", motorcycles: "Μοτοσυκλέτες", bicycles: "Ποδήλατα", catering: "Εκδηλώσεις & Κέιτερινγκ", tours: "Τουρ & Ξεναγός", contact: "Επικοινωνία", book: "Κράτηση", brand: "Rent Center Gevgelija" },
    hero: {
      line1: "Διαμερίσματα, βίλες,",
      line2: "αυτοκίνητα, μοτοσυκλέτες, ποδήλατα —",
      line3: "όλα στη Γκέβγελι.",
      sub: "Διαμερίσματα, βίλες, αυτοκίνητα, μοτοσυκλέτες και ποδήλατα — όλα για τη διαμονή σου στη Γκέβγελι, σε ένα site.",
      ctaExplore: "Δες διαμερίσματα",
      ctaContact: "Στείλε ερώτηση",
      stats1: "διαμερίσματα",
      stats2: "τοποθεσίες στην πόλη",
      stats3: "υποστήριξη",
      scroll: "Κύλιση",
    },
    marquee: ["Ιαματικές πηγές", "Ριβιέρα του Βαρδάρη", "Boutique διαμονή", "Η πόλη των φοινίκων", "Νυχτερινή ζωή & καζίνο", "Οικογενειακή φιλοξενία"],
    callStrip: { label: "Κάλεσέ μας απευθείας" },
    villas: { kicker: "Σύντομα", title: "Βίλες", sub: "Προσθέτουμε βίλες στη συλλογή μας. Αν ψάχνεις βίλα — στείλε μας μήνυμα στο Viber ή WhatsApp." },
    hotels: { kicker: "Σύντομα", title: "Ξενοδοχεία", sub: "Προσθέτουμε ξενοδοχεία στη συλλογή μας. Αν ψάχνεις ξενοδοχείο — στείλε μας μήνυμα στο Viber ή WhatsApp." },
    hotel: {
      sub: "Premium Inn — ξενοδοχείο στη Γκέβγελι με 6 τύπους δωματίων. Διάλεξε τύπο δωματίου για περισσότερες πληροφορίες.",
      subFeniks: "Fenix — ξενοδοχείο στη Γκέβγελι με 3 τύπους δωματίων. Διάλεξε τύπο δωματίου για περισσότερες πληροφορίες.",
      roomSub: "Λεπτομέρειες, τιμές και φωτογραφίες για αυτό το δωμάτιο θα δημοσιευτούν σύντομα. Για πληροφορίες στείλε μας μήνυμα στο Viber ή WhatsApp.",
      roomInfo: "Για κρατήσεις και περισσότερες πληροφορίες στείλε μας μήνυμα στο Viber ή WhatsApp.",
      waRoom: "Γεια σας! Ενδιαφέρομαι για {room} στο ξενοδοχείο {hotel} — έχετε διαθέσιμες ημερομηνίες;",
      rooms: { deluxeApartment: "Deluxe Διαμέρισμα", deluxeFamilyRoom: "Deluxe Οικογενειακό Δωμάτιο", familySuite: "Οικογενειακή Σουίτα", quadrupleRoom: "Τετράκλινο Δωμάτιο", tripleRoom: "Τρίκλινο Δωμάτιο", doubleRoom: "Δίκλινο Δωμάτιο", commonAreas: "Κοινόχρηστοι Χώροι" },
    },
    rental: { vehicles: "Ενοικίαση οχημάτων", motorcycles: "Ενοικίαση μοτοσυκλετών", bicycles: "Ενοικίαση ποδηλάτων", catering: "Ενοικίαση εκδηλώσεων και κέιτερινγκ", motoAll: "Όλα", tours: "Τοπικά τουρ και τουριστικός ξεναγός", sub: "Σύντομα — ετοιμάζουμε την προσφορά. Για πληροφορίες στείλε μας μήνυμα στο Viber ή WhatsApp." },
    grid: {
      kicker: "Η συλλογή",
      tabAll: "Όλα",
      greenPlace: "Green Place Διαμερίσματα",
      title: "Τα Διαμερίσματα",
      subtitle: "Κάθε διαμέρισμα είναι μια ξεχωριστή ιστορία — διάλεξε τη δική σου.",
      guests: "επισκέπτες",
      bedrooms: "υπνοδωμάτια",
      studio: "στούντιο",
      night: "βράδυ",
      from: "από",
      view: "Δες λεπτομέρειες",
      perNight: "/ βράδυ",
      comingSoon: "Σύντομα",
      comingSoonDetail: "Αυτό το διαμέρισμα θα είναι σύντομα διαθέσιμο για κρατήσεις. Για πληροφορίες κάλεσε +389 78 321 872 ή στείλε μήνυμα.",
    },
    manifesto: {
      kicker: "Μανιφέστο",
      title: "Γιατί Γκέβγελι",
      ch1t: "Η πόλη των φοινίκων",
      ch1d: "Η νοτιότερη πόλη της Βόρειας Μακεδονίας αναπνέει μεσογειακά — φοίνικες στις λεωφόρους, καφένεια που δεν βιάζονται ποτέ και ήλιος που μένει περισσότερο από οπουδήποτε αλλού.",
      ch2t: "Ιαματικές πηγές",
      ch2d: "Λίγα λεπτά από το κέντρο, τα φυσικά ιαματικά λουτρά της Σμρντλίβα Βόντα προσφέρουν ξεκούραση που οι Ρωμαίοι γνώριζαν πριν δύο χιλιετίες.",
      ch3t: "Η Ριβιέρα του Βαρδάρη",
      ch3d: "Η συνοριακή ζώνη συνδυάζει καζίνο, εστιατόρια και νυχτερινή ζωή με τον αργό ρυθμό του ποταμού — μια αντίθεση που δεν βρίσκεται πουθενά αλλού στα Βαλκάνια.",
    },
    detail: {
      back: "Όλα τα διαμερίσματα",
      availability: "Διαθεσιμότητα",
      selectDates: "Διάλεξε ημερομηνίες",
      checkIn: "Άφιξη",
      checkOut: "Αναχώρηση",
      guests: "Επισκέπτες",
      guest: "επισκέπτης",
      guestsP: "επισκέπτες",
      nights: "βράδια",
      night: "βράδυ",
      total: "Σύνολο",
      perNight: "ανά βράδυ",
      bookPay: "Κράτηση & πληρωμή",
      processing: "Επεξεργασία…",
      bookedLegend: "κρατημένο",
      selectedLegend: "επιλεγμένο",
      yourStay: "Η διαμονή σου",
      bookVia: "Κράτηση μέσω Viber / WhatsApp",
      bookViaSub: "Στείλε μας μήνυμα στο Viber ή WhatsApp με το διαμέρισμα και τις ημερομηνίες που θέλεις — απαντάμε την ίδια μέρα.",
      orCall: "ή κάλεσέ μας απευθείας",
      waMsg: "Γεια σας! Ενδιαφέρομαι για {name} — έχετε διαθέσιμες ημερομηνίες;",
      name: "Ονοματεπώνυμο",
      email: "Email",
      phone: "Τηλέφωνο",
      note: "Σημείωση (προαιρετικά)",
      namePh: "π.χ. Γιώργος Παπαδόπουλος",
      notePh: "Ώρα άφιξης, ερωτήσεις…",
      errDates: "Διάλεξε έγκυρες ημερομηνίες άφιξης και αναχώρησης.",
      errOverlap: "Οι επιλεγμένες ημερομηνίες είναι ήδη κρατημένες.",
      errGeneric: "Κάτι πήγε στραβά. Δοκίμασε ξανά.",
      amenities: "Παροχές",
      about: "Σχετικά με το διαμέρισμα",
      amenityList: {
        wifi: "Γρήγορο Wi-Fi",
        parking: "Ιδιωτικό πάρκινγκ",
        ac: "Κλιματισμός",
        kitchen: "Πλήρης κουζίνα",
        kitchenette: "Κουζινάκι",
        terrace: "Βεράντα",
        tv: "Smart TV",
        washer: "Πλυντήριο ρούχων",
        dishwasher: "Πλυντήριο πιάτων",
        coffee: "Καφετιέρα",
        workspace: "Γωνιά εργασίας",
        view: "Πανοραμική θέα",
        blackout: "Κουρτίνες συσκότισης",
        sauna: "Ιδιωτική σάουνα",
        jacuzzi: "Τζακούζι",
        garden: "Μεγάλος κήπος",
        summerKitchen: "Θερινή κουζίνα",
      },
    },
    contact: {
      kicker: "Επικοινωνία",
      title: "Έχεις ερώτηση;",
      subtitle: "Ρώτησέ μας για διαθεσιμότητα, ειδικές προσφορές ή μεγαλύτερες διαμονές — απαντάμε την ίδια μέρα.",
      name: "Όνομα",
      email: "Email",
      message: "Μήνυμα",
      send: "Αποστολή μηνύματος",
      sending: "Αποστολή…",
      success: "Το μήνυμα εστάλη. Θα σου απαντήσουμε σύντομα!",
      error: "Η αποστολή απέτυχε. Δοκίμασε ξανά.",
      namePh: "Το όνομά σου",
      emailPh: "you@example.com",
      messagePh: "Γεια σας, ενδιαφέρομαι για…",
      phoneLabel: "Τηλέφωνο / WhatsApp / Viber",
      phoneNote: "Είμαστε διαθέσιμοι σε WhatsApp και Viber",
      emailLabel: "Email",
      locationLabel: "Τοποθεσία",
    },
    footer: {
      tagline: "Boutique διαμερίσματα προς ενοικίαση στη Γκέβγελι — ένα site, κάθε τοποθεσία.",
      explore: "Εξερεύνηση",
      contact: "Επικοινωνία",
      rights: "Με επιφύλαξη παντός δικαιώματος.",
      apartments: "Διαμερίσματα",
      about: "Σχετικά με τη Γκέβγελι",
    },
    payment: {
      successTitle: "Η κράτηση επιβεβαιώθηκε",
      successSub: "Η πληρωμή ήταν επιτυχής. Τα στοιχεία της κράτησης παρακάτω — επιβεβαίωση θα φτάσει και στο email σου.",
      polling: "Επαληθεύουμε την πληρωμή σου…",
      bookingRef: "Κωδικός",
      dates: "Ημερομηνίες",
      paid: "Πληρώθηκε",
      backHome: "Πίσω στην αρχική",
      cancelTitle: "Η πληρωμή ακυρώθηκε",
      cancelSub: "Η κράτηση δεν ολοκληρώθηκε. Οι ημερομηνίες μπορεί να είναι ακόμα ελεύθερες — δοκίμασε ξανά.",
      tryAgain: "Δοκίμασε ξανά",
      failed: "Η πληρωμή δεν επιβεβαιώθηκε. Αν αφαιρέθηκαν χρήματα, επικοινώνησε μαζί μας.",
    },
    cal: {
      months: ["Ιανουάριος", "Φεβρουάριος", "Μάρτιος", "Απρίλιος", "Μάιος", "Ιούνιος", "Ιούλιος", "Αύγουστος", "Σεπτέμβριος", "Οκτώβριος", "Νοέμβριος", "Δεκέμβριος"],
      days: ["Δε", "Τρ", "Τε", "Πε", "Πα", "Σα", "Κυ"],
      prev: "Προηγούμενος μήνας",
      next: "Επόμενος μήνας",
    },
    notFound: "Η σελίδα δεν βρέθηκε.",
  },
  sr: {
    nav: { apartments: "Apartmani", hotels: "Hoteli", about: "Gevgelija", villas: "Vile", vehicles: "Vozila", motorcycles: "Motori", bicycles: "Bicikli", catering: "Događaji i ketering", tours: "Ture i vodič", contact: "Kontakt", book: "Rezerviši", brand: "Rent Center Gevgelija" },
    hero: {
      line1: "Apartmani, vile,",
      line2: "kola, motori, bicikli —",
      line3: "sve u Gevgeliji.",
      sub: "Apartmani, vile, kola, motori i bicikli — sve za tvoj boravak u Gevgeliji, na jednom sajtu.",
      ctaExplore: "Pogledaj apartmane",
      ctaContact: "Pošalji upit",
      stats1: "apartmana",
      stats2: "lokacija u gradu",
      stats3: "podrška",
      scroll: "Skroluj",
    },
    marquee: ["Termalni izvori", "Rivijera Vardara", "Butik smeštaj", "Grad palmi", "Kazino noćni život", "Domaćinska dobrodošlica"],
    callStrip: { label: "Pozovi nas direktno" },
    villas: { kicker: "Uskoro", title: "Vile", sub: "Radimo na dodavanju vila u ponudu. Ako tražiš vilu — javi nam se na Viber ili WhatsApp." },
    hotels: { kicker: "Uskoro", title: "Hoteli", sub: "Radimo na dodavanju hotela u ponudu. Ako tražiš hotel — javi nam se na Viber ili WhatsApp." },
    hotel: {
      sub: "Premium Inn — hotel u Gevgeliji sa 6 tipova soba. Izaberi tip sobe za više informacija.",
      subFeniks: "Fenix — hotel u Gevgeliji sa 3 tipa soba. Izaberi tip sobe za više informacija.",
      roomSub: "Detalji, cene i fotografije za ovu sobu će uskoro biti objavljeni. Za informacije javi nam se na Viber ili WhatsApp.",
      roomInfo: "Za rezervacije i dodatne informacije javi nam se na Viber ili WhatsApp.",
      waRoom: "Zdravo! Zanima me {room} u hotelu {hotel} — da li imate slobodne termine?",
      rooms: { deluxeApartment: "Deluxe Apartman", deluxeFamilyRoom: "Deluxe Porodična Soba", familySuite: "Porodični Suit", quadrupleRoom: "Četverokrevetna Soba", tripleRoom: "Trokrevetna Soba", doubleRoom: "Dvokrevetna Soba", commonAreas: "Zajedničke Prostorije" },
    },
    rental: { vehicles: "Iznajmljivanje vozila", motorcycles: "Iznajmljivanje motora", bicycles: "Iznajmljivanje bicikala", catering: "Iznajmljivanje za događaje i ketering", motoAll: "Svi", tours: "Lokalne ture i turistički vodič", sub: "Uskoro — spremamo ponudu. Za informacije javi nam se na Viber ili WhatsApp." },
    grid: {
      kicker: "Kolekcija",
      tabAll: "Svi",
      greenPlace: "Green Place Apartmani",
      title: "Apartmani",
      subtitle: "Svaki apartman je posebna priča — izaberi svoju.",
      guests: "gostiju",
      bedrooms: "spavaće sobe",
      studio: "studio",
      night: "noć",
      from: "od",
      view: "Vidi detalje",
      perNight: "/ noć",
      comingSoon: "Uskoro",
      comingSoonDetail: "Ovaj apartman će uskoro biti dostupan za rezervacije. Za informacije pozovi +389 78 321 872 ili pošalji poruku.",
    },
    manifesto: {
      kicker: "Manifest",
      title: "Zašto Gevgelija",
      ch1t: "Grad palmi",
      ch1d: "Najjužniji grad Severne Makedonije diše mediteranski — palme duž bulevara, kafići koji nikad ne žure i sunce koje ostaje duže nego igde drugde.",
      ch2t: "Termalni izvori",
      ch2d: "Na par minuta od centra, prirodne termalne banje Smrdlive Vode nude odmor koji su Rimljani poznavali pre dva milenijuma.",
      ch3t: "Rivijera Vardara",
      ch3d: "Granična zona spaja kazina, restorane i noćni život sa tihim tempom reke — kontrast koji se ne nalazi nigde drugde na Balkanu.",
    },
    detail: {
      back: "Svi apartmani",
      availability: "Dostupnost",
      selectDates: "Izaberi datume",
      checkIn: "Prijava",
      checkOut: "Odjava",
      guests: "Gosti",
      guest: "gost",
      guestsP: "gostiju",
      nights: "noći",
      night: "noć",
      total: "Ukupno",
      perNight: "po noći",
      bookPay: "Rezerviši i plati",
      processing: "Obrada…",
      bookedLegend: "zauzeto",
      selectedLegend: "izabrano",
      yourStay: "Tvoj boravak",
      bookVia: "Rezerviši preko Viber / WhatsApp",
      bookViaSub: "Pošalji nam poruku na Viber ili WhatsApp sa apartmanom i datumima koji te interesuju — odgovaramo isti dan.",
      orCall: "ili nas pozovi direktno",
      waMsg: "Zdravo! Zanima me {name} — da li imate slobodne termine?",
      name: "Ime i prezime",
      email: "Email",
      phone: "Telefon",
      note: "Napomena (opciono)",
      namePh: "npr. Petar Petrović",
      notePh: "Vreme dolaska, pitanja…",
      errDates: "Izaberi validne datume prijave i odjave.",
      errOverlap: "Izabrani datumi su već zauzeti.",
      errGeneric: "Nešto je pošlo po zlu. Pokušaj ponovo.",
      amenities: "Pogodnosti",
      about: "O apartmanu",
      amenityList: {
        wifi: "Brz Wi-Fi",
        parking: "Privatni parking",
        ac: "Klima",
        kitchen: "Kompletna kuhinja",
        kitchenette: "Mini kuhinja",
        terrace: "Terasa",
        tv: "Smart TV",
        washer: "Mašina za pranje",
        dishwasher: "Mašina za sudove",
        coffee: "Aparat za kafu",
        workspace: "Radni ugao",
        view: "Panoramski pogled",
        blackout: "Zavese za zamračenje",
        sauna: "Privatna sauna",
        jacuzzi: "Đakuzi",
        garden: "Veliko dvorište",
        summerKitchen: "Letnja kuhinja",
      },
    },
    contact: {
      kicker: "Kontakt",
      title: "Imaš pitanje?",
      subtitle: "Piši nam za dostupnost, posebne ponude ili duže boravke — odgovaramo isti dan.",
      name: "Ime",
      email: "Email",
      message: "Poruka",
      send: "Pošalji poruku",
      sending: "Slanje…",
      success: "Poruka je poslata. Javljamo ti uskoro!",
      error: "Slanje nije uspelo. Pokušaj ponovo.",
      namePh: "Tvoje ime",
      emailPh: "ti@primer.com",
      messagePh: "Zdravo, zanima me…",
      phoneLabel: "Telefon / WhatsApp / Viber",
      phoneNote: "Dostupni smo na WhatsApp i Viber",
      emailLabel: "Email",
      locationLabel: "Lokacija",
    },
    footer: {
      tagline: "Butik apartmani za izdavanje u Gevgeliji — jedan sajt, sve lokacije.",
      explore: "Istraži",
      contact: "Kontakt",
      rights: "Sva prava zadržana.",
      apartments: "Apartmani",
      about: "O Gevgeliji",
    },
    payment: {
      successTitle: "Rezervacija je potvrđena",
      successSub: "Plaćanje je uspešno. Detalji rezervacije su ispod — potvrda stiže i na email.",
      polling: "Proveravamo uplatu…",
      bookingRef: "Referenca",
      dates: "Datumi",
      paid: "Plaćeno",
      backHome: "Nazad na početnu",
      cancelTitle: "Plaćanje je otkazano",
      cancelSub: "Rezervacija nije završena. Datumi su možda još slobodni — pokušaj ponovo.",
      tryAgain: "Pokušaj ponovo",
      failed: "Uplata nije potvrđena. Ako su ti novci skinuti, kontaktiraj nas.",
    },
    cal: {
      months: ["Januar", "Februar", "Mart", "April", "Maj", "Jun", "Jul", "Avgust", "Septembar", "Oktobar", "Novembar", "Decembar"],
      days: ["Po", "Ut", "Sr", "Če", "Pe", "Su", "Ne"],
      prev: "Prethodni mesec",
      next: "Sledeći mesec",
    },
    notFound: "Stranica nije pronađena.",
  },
  ro: {
    nav: { apartments: "Apartamente", hotels: "Hoteluri", about: "Gevgelija", villas: "Vile", vehicles: "Vehicule", motorcycles: "Motociclete", bicycles: "Biciclete", catering: "Evenimente & Catering", tours: "Tururi & Ghid", contact: "Contact", book: "Rezervă", brand: "Rent Center Gevgelija" },
    hero: {
      line1: "Apartamente, vile,",
      line2: "mașini, motociclete, biciclete —",
      line3: "totul în Gevgelija.",
      sub: "Apartamente, vile, mașini, motociclete și biciclete — totul pentru șederea ta în Gevgelija, pe un singur site.",
      ctaExplore: "Vezi apartamentele",
      ctaContact: "Trimite o întrebare",
      stats1: "apartamente",
      stats2: "locații în oraș",
      stats3: "suport",
      scroll: "Derulează",
    },
    marquee: ["Izvor termale", "Riviera Vardarului", "Cazare boutique", "Orașul palmierilor", "Viață de noapte & cazinouri", "Gazdă primitoare"],
    callStrip: { label: "Sună-ne direct" },
    villas: { kicker: "În curând", title: "Vile", sub: "Lucrăm la adăugarea vilor în ofertă. Dacă cauți o vilă — scrie-ne pe Viber sau WhatsApp." },
    hotels: { kicker: "În curând", title: "Hoteluri", sub: "Lucrăm la adăugarea hotelurilor în ofertă. Dacă cauți un hotel — scrie-ne pe Viber sau WhatsApp." },
    hotel: {
      sub: "Premium Inn — un hotel în Gevgelija cu 6 tipuri de camere. Alege tipul de cameră pentru mai multe informații.",
      subFeniks: "Fenix — un hotel în Gevgelija cu 3 tipuri de camere. Alege tipul de cameră pentru mai multe informații.",
      roomSub: "Detaliile, prețurile și fotografiile pentru această cameră vor fi publicate în curând. Pentru informații scrie-ne pe Viber sau WhatsApp.",
      roomInfo: "Pentru rezervări și informații suplimentare scrie-ne pe Viber sau WhatsApp.",
      waRoom: "Bună! Mă interesează {room} la hotelul {hotel} — aveți date disponibile?",
      rooms: { deluxeApartment: "Apartament Deluxe", deluxeFamilyRoom: "Cameră de Familie Deluxe", familySuite: "Suită de Familie", quadrupleRoom: "Cameră Cvadruplă", tripleRoom: "Cameră Triplă", doubleRoom: "Cameră Dublă", commonAreas: "Spații Comune" },
    },
    rental: { vehicles: "Închiriere vehicule", motorcycles: "Închiriere motociclete", bicycles: "Închiriere biciclete", catering: "Închirieri pentru evenimente și catering", motoAll: "Toate", tours: "Tururi locale și ghid turistic", sub: "În curând — pregătim oferta. Pentru informații scrie-ne pe Viber sau WhatsApp." },
    grid: {
      kicker: "Colecția",
      tabAll: "Toate",
      greenPlace: "Apartamente Green Place",
      title: "Apartamentele",
      subtitle: "Fiecare apartament e o poveste separată — alege-o pe a ta.",
      guests: "oaspeți",
      bedrooms: "dormitoare",
      studio: "studio",
      night: "noapte",
      from: "de la",
      view: "Vezi detalii",
      perNight: "/ noapte",
      comingSoon: "În curând",
      comingSoonDetail: "Acest apartament va fi disponibil în curând pentru rezervări. Pentru informații sună la +389 78 321 872 sau trimite un mesaj.",
    },
    manifesto: {
      kicker: "Manifest",
      title: "De ce Gevgelija",
      ch1t: "Orașul palmierilor",
      ch1d: "Cel mai sudic oraș al Macedoniei de Nord respiră mediteranean — palmieri de-a lungul bulevardelor, cafenele care nu se grăbesc niciodată și soare care rămâne mai mult ca oriunde altundeva.",
      ch2t: "Izvor termale",
      ch2d: "La câteva minute de centru, băile termale naturale de la Smrdliva Voda oferă odihna pe care romanii o cunoșteau acum două milenii.",
      ch3t: "Riviera Vardarului",
      ch3d: "Fâșia de frontieră combină cazinouri, restaurante și viață de noapte cu ritmul lent al râului — un contrast care nu se găsește nicăieri altundeva în Balcani.",
    },
    detail: {
      back: "Toate apartamentele",
      availability: "Disponibilitate",
      selectDates: "Alege datele",
      checkIn: "Check-in",
      checkOut: "Check-out",
      guests: "Oaspeți",
      guest: "oaspete",
      guestsP: "oaspeți",
      nights: "nopți",
      night: "noapte",
      total: "Total",
      perNight: "pe noapte",
      bookPay: "Rezervă și plătește",
      processing: "Se procesează…",
      bookedLegend: "rezervat",
      selectedLegend: "selectat",
      yourStay: "Șederea ta",
      bookVia: "Rezervă prin Viber / WhatsApp",
      bookViaSub: "Trimite-ne un mesaj pe Viber sau WhatsApp cu apartamentul și datele dorite — răspundem în aceeași zi.",
      orCall: "sau sună-ne direct",
      waMsg: "Bună! Mă interesează {name} — aveți date disponibile?",
      name: "Nume complet",
      email: "Email",
      phone: "Telefon",
      note: "Notă (opțional)",
      namePh: "ex. Andrei Popescu",
      notePh: "Ora sosirii, întrebări…",
      errDates: "Alege date valide de check-in și check-out.",
      errOverlap: "Datele selectate sunt deja rezervate.",
      errGeneric: "Ceva a mers greșit. Încearcă din nou.",
      amenities: "Facilități",
      about: "Despre apartament",
      amenityList: {
        wifi: "Wi-Fi rapid",
        parking: "Parcare privată",
        ac: "Aer condiționat",
        kitchen: "Bucătărie completă",
        kitchenette: "Bucătărie mică",
        terrace: "Terasă",
        tv: "Smart TV",
        washer: "Mașină de spălat",
        dishwasher: "Mașină de vase",
        coffee: "Aparat de cafea",
        workspace: "Colț de lucru",
        view: "Priveliște panoramică",
        blackout: "Draperii opace",
        sauna: "Saună privată",
        jacuzzi: "Jacuzzi",
        garden: "Curte mare",
        summerKitchen: "Bucătărie de vară",
      },
    },
    contact: {
      kicker: "Contact",
      title: "Ai o întrebare?",
      subtitle: "Întreabă-ne despre disponibilitate, oferte speciale sau șederi lungi — răspundem în aceeași zi.",
      name: "Nume",
      email: "Email",
      message: "Mesaj",
      send: "Trimite mesajul",
      sending: "Se trimite…",
      success: "Mesajul a fost trimis. Îți răspundem în curând!",
      error: "Trimiterea a eșuat. Încearcă din nou.",
      namePh: "Numele tău",
      emailPh: "tu@exemplu.com",
      messagePh: "Bună, mă interesează…",
      phoneLabel: "Telefon / WhatsApp / Viber",
      phoneNote: "Suntem disponibili pe WhatsApp și Viber",
      emailLabel: "Email",
      locationLabel: "Locație",
    },
    footer: {
      tagline: "Apartamente boutique de închiriat în Gevgelija — un singur site, toate locațiile.",
      explore: "Explorează",
      contact: "Contact",
      rights: "Toate drepturile rezervate.",
      apartments: "Apartamente",
      about: "Despre Gevgelija",
    },
    payment: {
      successTitle: "Rezervarea este confirmată",
      successSub: "Plata a reușit. Detaliile rezervării sunt mai jos — o confirmare ajunge și pe email.",
      polling: "Verificăm plata…",
      bookingRef: "Referință",
      dates: "Date",
      paid: "Plătit",
      backHome: "Înapoi la pagina principală",
      cancelTitle: "Plata a fost anulată",
      cancelSub: "Rezervarea nu a fost finalizată. Datele ar putea fi încă libere — încearcă din nou.",
      tryAgain: "Încearcă din nou",
      failed: "Plata nu a fost confirmată. Dacă ți s-au retras bani, contactează-ne.",
    },
    cal: {
      months: ["Ianuarie", "Februarie", "Martie", "Aprilie", "Mai", "Iunie", "Iulie", "August", "Septembrie", "Octombrie", "Noiembrie", "Decembrie"],
      days: ["Lu", "Ma", "Mi", "Jo", "Vi", "Sâ", "Du"],
      prev: "Luna anterioară",
      next: "Luna următoare",
    },
    notFound: "Pagina nu a fost găsită.",
  },
};

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("rg-lang") || "mk");
  const change = useCallback((l) => {
    localStorage.setItem("rg-lang", l);
    setLang(l);
  }, []);
  const t = useCallback(
    (path) => {
      const val = path.split(".").reduce((acc, k) => (acc ? acc[k] : undefined), dictionaries[lang]);
      return val !== undefined ? val : path;
    },
    [lang]
  );
  return <LangContext.Provider value={{ lang, setLang: change, t }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
